import React from 'react';
import PropTypes from 'prop-types';
import Hotspot from './Hotspot';


class ModalHotspotCircle extends Hotspot {
    constructor(props) {
        super(props);
    }

    getPlainSVG(color) {
            return (
        <svg width="436px" height="436px" viewBox="0 0 436 436" version="1.1">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="template-image-hotspot-icon" transform="translate(18.000000, 18.000000)" stroke="#FFFFFF">
                <g id="Group" transform="translate(200.000000, 200.000000) rotate(-180.000000) translate(-200.000000, -200.000000) translate(0.000000, -0.000000)">
                    <circle id="Oval" stroke-width="35" fill={color} fill-rule="nonzero" cx="200" cy="200" r="200"></circle>
                    <g id="expand" stroke-linecap="round" transform="translate(114.000000, 115.000000)" stroke-width="15">
                        <line x1="103.5" y1="68.5" x2="170.5" y2="1.5" id="Path-3"></line>
                        <line x1="0.5" y1="171.5" x2="67.5" y2="104.5" id="Path-4"></line>
                        <line x1="0.5" y1="171.5" x2="0.5" y2="120.5" id="Path-5"></line>
                        <line x1="0.5" y1="171.5" x2="52.5" y2="171.5" id="Path-5"></line>
                        <line x1="120" y1="1" x2="171" y2="1" id="Path-5"></line>
                        <line x1="171" y1="2" x2="171" y2="54" id="Path-5"></line>
                    </g>
                </g>
            </g>
        </g>
        </svg>
            )
    }


}

ModalHotspotCircle.propTypes = { primaryColor: PropTypes.string.isRequired, };
export default ModalHotspotCircle;

